import { render, staticRenderFns } from "./ReportTopCustomer.vue?vue&type=template&id=e0b98d7a&"
import script from "./ReportTopCustomer.vue?vue&type=script&lang=js&"
export * from "./ReportTopCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports